import React from 'react';
import { useAuth } from './AuthProvider';
import { AuthScreen } from './AuthScreen';

export const ProtectedRoute = ({ children }) => {
  const { isAuthEnabled, authConfigured, isAuthenticated, loading, refreshAuth } = useAuth();

  // If auth is disabled, render children directly
  if (!isAuthEnabled) {
    return children;
  }

  // If auth is not configured, show error
  if (!authConfigured) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Authentication Configuration Error</h2>
        <p>Please run <code>configure-auth.sh</code> to set up authentication.</p>
      </div>
    );
  }

  // Show loading state
  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  // If authenticated, render children
  if (isAuthenticated) {
    return children;
  }

  // Show CloudScape auth screen (login/signup)
  return <AuthScreen onSuccess={refreshAuth} />;
};
